import { TechnicalParameterModalConfig } from "../types/product-card-technical-parameter.types";
import {ProductPackageModalComponent} from "../components/modals/product-package-modal/product-package-modal.component";
import {DeclarationModalComponent} from "../components/modals/declaration-modal/declaration-modal.component";
import {CertificateModalComponent} from "../components/modals/certificate-modal/certificate-modal.component";
import {
  FactoryBankDetailsModalComponent
} from "../components/modals/factory-bank-details-modal/factory-bank-details-modal.component";
import {
  TechnicalConclusionModalComponent
} from "../components/modals/technical-conclusion-modal/technical-conclusion-modal.component";
import {
  ProductCompositionsModalComponent
} from "../components/modals/product-compositions-modal/product-compositions-modal.component";
import {TpTurnkeyCostModalComponent} from "../components/modals/tp-turnkey-cost-modal/tp-turnkey-cost-modal.component";
import {ArticleModalComponent} from "../components/modals/article-modal/article-modal.component";
import {
  ImportProductPackagesModalComponent
} from "../components/modals/import-product-packages-modal/import-product-packages-modal.component";
import {
  UnitEconomicsCalculationsModalComponent
} from "../components/modals/unit-economics-calculations-modal/unit-economics-calculations-modal.component";

const FIELD_CONFIGS = {
  productPackages: { component: ProductPackageModalComponent, width: '550px' },
  declarations: { component: DeclarationModalComponent, width: '450px' },
  certificates: { component: CertificateModalComponent, width: '450px' },
  factoryBankDetails: { component: FactoryBankDetailsModalComponent, width: '720px' },
  turnkeyCostToWarehouses: { component: TpTurnkeyCostModalComponent, width: '450px' },
  turnkeyCostToMarketplaces: { component: TpTurnkeyCostModalComponent, width: '450px' },
  technicalConclusions: { component: TechnicalConclusionModalComponent, width: '450px' },
  productCompositions: { component: ProductCompositionsModalComponent, width: '450px' },
  nmIds: { component: ArticleModalComponent, width: '450px' },
  skus: { component: ArticleModalComponent, width: '450px' },
  importProductPackages: { component: ImportProductPackagesModalComponent, width: '450px' },
  unitEconomicsCalculations: { component: UnitEconomicsCalculationsModalComponent, width: '450px' }
} as const;

export const technicalParameterModalConfig: Record<string, TechnicalParameterModalConfig> =
  Object.fromEntries(
    Object.entries(FIELD_CONFIGS).map(([fieldName, config]) => [
      fieldName,
      {
        ...config,
        fieldName
      }
    ])
  );
